import { render, staticRenderFns } from "./GradientLegend.vue?vue&type=template&id=55bfb231&"
import script from "./GradientLegend.vue?vue&type=script&lang=ts&"
export * from "./GradientLegend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports